document.addEventListener("DOMContentLoaded", () => {
  const MainSubWidget = document.querySelectorAll('.product__subs__wrap');

  // helper: podmiana ID wariantu + (opcjonalnie) czyszczenie selling_plan
  function updateFormVariant(sectionID, variantId, { clearSellingPlan = false } = {}) {
    document.querySelectorAll('product-form[data-section-id]').forEach(form => {
      if (form && form.getAttribute('data-section-id') == sectionID) {
        const idInput = form.querySelector('form input[name="id"]');
        if (idInput && variantId) idInput.value = String(variantId);
        if (clearSellingPlan) {
          const spInput = form.querySelector('form [name="selling_plan"]');
          if (spInput) spInput.value = '';
        }
      }
    });
  }

  if (MainSubWidget.length > 0) {
    MainSubWidget.forEach(subWidget => {
      const WidgetButtons = subWidget.querySelectorAll('.product__subs__group');

      // ID z data-atrybutów (jeśli nie ma, weźmiemy z formularza)
      let BASE_VARIANT_ID = subWidget.dataset.baseVariantId || subWidget.querySelector('[data-base-variant-id]')?.value || null;
      const SUB_VARIANT_ID  = subWidget.dataset.subVariantId  || subWidget.querySelector('[data-sub-variant-id]')?.value  || null;

      // Fallback: jeśli nie podano data-base-variant-id, zapisz aktualny wariant z formularza tej sekcji
      if (!BASE_VARIANT_ID) {
        const sectionID = subWidget.getAttribute('data-subSection-id');
        const firstForm = Array.from(document.querySelectorAll('product-form[data-section-id]'))
          .find(f => f.getAttribute('data-section-id') == sectionID);
        const idInput = firstForm?.querySelector('form input[name="id"]');
        if (idInput?.value) BASE_VARIANT_ID = idInput.value;
      }

      if (WidgetButtons.length > 0) {
        WidgetButtons.forEach(button => {
          if (button) {
            const sectionID = subWidget.getAttribute('data-subSection-id');
            const innerLabel = button.querySelector('label');
            const labelInnerInput = innerLabel.querySelector('[data-button = "onetime"]');

            if (labelInnerInput) {
              setTimeout(() => { labelInnerInput.click() }, 600);
            }

            innerLabel.addEventListener('click', () => {
              var data_new = button.querySelector('.one_time_colomn input')?.getAttribute('data-button');

              if (data_new === 'onetime') {
                // --- Twoja logika cen (bez zmian) ---
                var bundleItems = document.querySelectorAll('.featured-product .bundle_selector_wrapper .bundle_items');
                bundleItems.forEach(function (item) {
                  var otpPrice = item.getAttribute('new_price_one');
                  var displayPrice = otpPrice + ' / Opakowanie';
                  var priceElement = item.querySelector('.pro_price');
                  if (priceElement) priceElement.textContent = displayPrice;
                });
                var activeItem = document.querySelector('.bundle_items.active');
                if (activeItem) {
                  var newPriceOne = activeItem.getAttribute('new_price_one');
                  var lasDataElement = document.querySelector('.featured-product .pre_serving_wrapper .text.las_data');
                  if (lasDataElement) lasDataElement.textContent = newPriceOne + ' / serving';
                  var servingTextElement = activeItem.querySelector('.serving_text');
                  if (servingTextElement) {
                    var servingText = servingTextElement.textContent.trim();
                    var serPerElement = document.querySelector('.featured-product .pre_serving_wrapper .text.ser_per');
                    if (serPerElement) serPerElement.textContent = servingText;
                  }
                }
                // --- [ISTOTNE] wróć do wariantu bazowego + wyczyść selling_plan
                updateFormVariant(sectionID, BASE_VARIANT_ID, { clearSellingPlan: true });

              } else if (data_new === 'subscription') {
                // --- Twoja logika cen (bez zmian) ---
                var bundleItems = document.querySelectorAll('.featured-product .bundle_selector_wrapper .bundle_items');
                bundleItems.forEach(function (item) {
                  var otpPrice = item.getAttribute('new_dis_price_sub');
                  var displayPrice = otpPrice + ' / Opakowanie';
                  var priceElement = item.querySelector('.pro_price');
                  if (priceElement) priceElement.textContent = displayPrice;
                });
                var activeItem = document.querySelector('.bundle_items.active');
                if (activeItem) {
                  var newPriceOne = activeItem.getAttribute('new_dis_price_sub');
                  var lasDataElement = document.querySelector('.featured-product .pre_serving_wrapper .text.las_data');
                  if (lasDataElement) lasDataElement.textContent = newPriceOne + ' / serving';
                  var servingTextElement = activeItem.querySelector('.serving_text');
                  if (servingTextElement) {
                    var servingText = servingTextElement.textContent.trim();
                    var serPerElement = document.querySelector('.featured-product .pre_serving_wrapper .text.ser_per');
                    if (serPerElement) serPerElement.textContent = servingText;
                  }
                }
                // --- [ISTOTNE] ustaw wariant subskrypcyjny (bez czyszczenia selling_plan)
                updateFormVariant(sectionID, SUB_VARIANT_ID);
              }

              // --- Twoja dotychczasowa obsługa selling_plan (bez zmian) ---
              if (button.querySelector('input[name="current_selling_plan"]')) {
                const SubscriptionSellingIDInput = button.querySelector('input[name="current_selling_plan"]');
                const CurrentSellingID = SubscriptionSellingIDInput.getAttribute('value');
                const NearestForm = document.querySelectorAll('product-form[data-section-id]');
                if (NearestForm.length > 0) {
                  NearestForm.forEach(form => {
                    if (form) {
                      const formID = form.getAttribute('data-section-id');
                      if (formID == sectionID) {
                        const SellingInput = form.querySelector('form [name="selling_plan"]');
                        if (SellingInput) {
                          SellingInput.setAttribute('value', CurrentSellingID);
                        }
                      }
                    }
                  })
                }
              } else {
                const NearestForm = document.querySelectorAll('product-form[data-section-id]');
                if (NearestForm.length > 0) {
                  NearestForm.forEach(form => {
                    if (form) {
                      const formID = form.getAttribute('data-section-id');
                      if (formID == sectionID) {
                        const SellingInput = form.querySelector('form [name="selling_plan"]');
                        if (SellingInput) {
                          SellingInput.setAttribute('value', '');
                        }
                      }
                    }
                  })
                }
              }
            })
          }
        })
      }
    })
  }
});
